import classcat from "classcat";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import CircularThumbnails from "@is/components/CircularThumbnails";
import Radio from "@is/components/Radio";
import { ALL_ITEMS_COLLECTION_ID, TranslationContext } from "@is/constants";
import { CollectionListItem } from "@is/types";

import css from "./Collection.module.css";

type Props = {
  collection: CollectionListItem;
  onCollectionClick: (collectionId: string) => void;
  selection?: boolean;
  isSelected?: boolean;
};

const Collection = ({
  collection,
  onCollectionClick,
  selection = false,
  isSelected = false,
}: Props) => {
  const { t } = useTranslation(TranslationContext.General);

  const handleClick = useCallback(() => {
    onCollectionClick(collection.id);
  }, [collection, onCollectionClick]);

  return (
    <div className={css.container} onClick={handleClick}>
      <div className={css.leftSide}>
        {selection ? (
          <div className={css.radio}>
            <Radio checked={isSelected} onChange={handleClick} title="" />
          </div>
        ) : null}

        <div className={css.infoContainer}>
          <h5 className={classcat([css.title, "text-label-xl"])}>
            {collection.id === ALL_ITEMS_COLLECTION_ID
              ? t("All Items")
              : collection.name}
          </h5>
          <span className={css.totalItems}>
            {`${collection.totalItems} ${
              collection.totalItems > 1 ? t("Items") : t("Item")
            }`}
          </span>
        </div>
      </div>

      <CircularThumbnails
        thumbnails={collection.thumbnails}
        totalItems={collection.totalItems}
      />
    </div>
  );
};

export default Collection;
